import React, {Component} from 'react';
import { LinkContainer } from "react-router-bootstrap";


class Compartir extends Component {

    
render() {   

    var LinkFacebook = "https://www.facebook.com/dialog/share?app_id=1483313925272843&display=page&href=http://www.aquibergueda.cat/eleccions/parlament/2021"+ this.props.url +"&redirect_uri=http://www.aquibergueda.cat/eleccions/parlament/2021"+ this.props.url;
    if (this.props.text) LinkFacebook += "&quote=" + this.props.text + " via Aquí Berguedà";

    var LinkTwitter = "https://twitter.com/intent/tweet?text="
    if (this.props.text) LinkTwitter += this.props.text + " ";
    LinkTwitter = encodeURI(LinkTwitter, "UTF-8");
    LinkTwitter += "http://www.aquibergueda.cat/eleccions/parlament/2021" + this.props.url + " via @AquiBergueda";

    var LinkWhatsapp = "https://wa.me/?text="
    if (this.props.text) LinkWhatsapp += this.props.text + " ";
    LinkWhatsapp = encodeURI(LinkWhatsapp, "UTF-8");
    LinkWhatsapp += "http://www.aquibergueda.cat/eleccions/parlament/2021" + this.props.url + " via Aquí Berguedà&lang=ca";

    var LinkTelegram = "https://t.me/share/url?url=http://www.aquibergueda.cat/eleccions/parlament/2021" + this.props.url;
    if (this.props.text) LinkTelegram +=  "&text=" + this.props.text + " via Aquí Berguedà";
    LinkTelegram = encodeURI(LinkTelegram, "UTF-8");

    

  return (
    <div className="compartir">
            <h6>Comparteix-ho a la xarxa!</h6>
           <div className="facebook"><a href={LinkFacebook} target="_blank">Facebook</a></div>
           <div className="twitter"><a href={LinkTwitter} target="_blank">Twitter</a></div>
           <div className="whatsapp"><a href={LinkWhatsapp} target="_blank">Whatsapp</a></div>
           <div className="telegram"><a href={LinkTelegram} target="_blank">Telegram</a></div>
    </div>
  );
}

}

export default Compartir; 